import React from 'react';
import { Reveal } from './Reveal';
import { brandChips, levelTags } from '../data/content';
export function BrandReveal() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-35" data-mp="3ueugrguxjrno">
      <div className="mx-auto w-full max-w-5xl text-center" data-id="element-36" data-mp="3qeaj8c6g2m10">
        <Reveal data-id="element-37" data-mp="3qcfwcsbm4jua">
          <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-widest text-navy" data-id="element-38" data-mp="3lfpeq0k5tg6r">
            The complete system for modern cheer coaches
          </p>

          <h2 className="mt-8 font-display text-4xl font-black uppercase leading-[1.05] tracking-tight text-navy sm:text-5xl md:text-6xl" data-id="element-39" data-mp="hza0w9x0arqh">
            Cheerleading Ready <span className="text-cheer" data-id="element-40" data-mp="cy2sq9qybqja">360</span>™
          </h2>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-navy/70" data-id="element-41" data-mp="7zri3wsu1c00">
            Six volumes. 360+ pages. Progressions, drills, stunt safety, routines and team
            management.{' '}
            <strong className="font-bold text-navy" data-id="element-42" data-mp="2sqa6fijvq1ej">Everything ready.</strong>
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-43" data-mp="1aepz05duy1zw">
          <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-44" data-mp="1abkc8wspbc7c">
            {brandChips.map(chip => <div key={chip.label} className="rounded-card border border-navy/10 bg-blush px-4 py-7" data-id="element-45" data-mp="10f7k43ct16ep">
                <p className="font-display text-3xl font-extrabold tracking-tight text-navy" data-id="element-46" data-mp="15d0sn31kyci5">
                  {chip.value}
                </p>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-navy/60" data-id="element-47" data-mp="vg4f2iwtr06q">
                  {chip.label}
                </p>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.12} data-id="element-48" data-mp="mnauq72itam0">
          <ul className="mt-10 flex flex-wrap items-center justify-center gap-3" data-id="element-49" data-mp="mom18encowgt">
            {levelTags.map(tag => <li key={tag} className="rounded-full border border-navy/10 bg-white px-4 py-2 text-sm font-semibold text-navy" data-id="element-50" data-mp="7rbn0xjbpche">
                {tag}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}